import { render, staticRenderFns } from "./GalleryTemplate.vue?vue&type=template&id=4c0b6d3a&scoped=true&"
import script from "./GalleryTemplate.vue?vue&type=script&lang=js&"
export * from "./GalleryTemplate.vue?vue&type=script&lang=js&"
import style0 from "./GalleryTemplate.vue?vue&type=style&index=0&id=4c0b6d3a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c0b6d3a",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VSheet})
